import React from 'react';
import PropTypes from 'prop-types';

const CustomText = ({ textKey, className }) => {
  const text = (window.customText || {})[textKey];

  if (!text) {
    return null;
  }

  return <p className={className} dangerouslySetInnerHTML={{ __html: text }} />;
};

CustomText.propTypes = {
  textKey: PropTypes.string.isRequired,
  className: PropTypes.string,
};

CustomText.defaultProps = {
  className: null,
};

export default CustomText;
